import { mapKeys } from "lodash";

export const mapDataKeys = keysMap => response => ({
  ...response,
  data: mapKeys(response.data, (value, key) => keysMap[key] || key),
});
